import React from 'react';
import { CheckCircle2, X } from 'lucide-react';

const WorkflowCopyModeToast = ({ label, count = 1, onDismiss }) => {
  const headline = count === 1 ? `Copied: ${label}` : `Copied: ${count} actions`;

  return (
    <div
      className="pointer-events-auto fixed bottom-6 left-6 z-50 flex max-w-sm items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-lg"
      data-testid="workflow-copy-mode-toast"
      role="status"
      aria-live="polite"
    >
      <CheckCircle2 size={20} className="mt-0.5 flex-shrink-0 text-emerald-600" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-slate-900">{headline}</p>
        <p className="mt-0.5 text-xs text-slate-600">Click a paste icon to insert</p>
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Cancel copy mode"
        className="rounded-md p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/40"
        data-testid="workflow-copy-mode-dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default WorkflowCopyModeToast;
